import { makeStyles } from '@material-ui/core'
import { loginBackground } from 'src/assets/png'

export const useStyles = makeStyles((theme) => ({
  resetPasswordContainer: {
    width: '100%',
    height: '100vh',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    gap: theme.app.spacing.base,
    alignItems: 'stretch',
    color: '#FFF',
    background: `linear-gradient(0deg, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), ${theme.palette.primary.main}`,
    padding: 0,
    overflow: 'hidden',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      gap: 0,
      justifyContent: 'center',
      alignItems: 'center',
      background: '#301e1a'
    },

    '& .reset-password__button': {
      height: 56,
      fontSize: theme.app.typography.body.fontSize,
      fontWeight: 500,
      color: '#FFFFFF',
      width: '100%',
      border: 'none',
      backgroundColor: theme.palette.primary.main,
      boxShadow: '0px 2px 8px rgba(120, 74, 66, 0.15)',
      borderRadius: theme.app.borderRadius.lg,
      marginTop: 20,
      cursor: 'pointer',
      textAlign: 'center',
      transition: 'all 0.2s',
      '&:hover': {
        backgroundColor: '#6a3f38'
      },
      '&:disabled': {
        opacity: 0.6,
        cursor: 'not-allowed'
      }
    },

    '& .reset-password__button-secondary': {
      height: 56,
      fontSize: theme.app.typography.body.fontSize,
      fontWeight: 500,
      color: theme.palette.primary.main,
      width: '100%',
      border: `2px solid ${theme.palette.primary.main}`,
      backgroundColor: 'transparent',
      boxShadow: '0px 2px 8px rgba(120, 74, 66, 0.15)',
      borderRadius: theme.app.borderRadius.lg,
      marginTop: theme.app.spacing.md,
      cursor: 'pointer',
      textAlign: 'center',
      transition: 'all 0.2s',
      '&:hover': {
        backgroundColor: 'rgba(120, 74, 66, 0.1)'
      },
      '&:disabled': {
        opacity: 0.6,
        cursor: 'not-allowed'
      }
    }
  },

  resetPasswordForm: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'center',
    padding: '40px 60px',
    gap: theme.app.spacing.xxl,
    flex: 1,
    minWidth: 0,
    // maxWidth: 732,
    height: '100vh',
    overflow: 'auto',
    [theme.breakpoints.down('md')]: {
      width: '100%',
      maxWidth: 'unset',
      padding: 30,
      gap: theme.app.spacing.xxl,
      height: 'auto'
    },
    '& form': {
      width: '100%'
    }
  },

  resetPasswordImageSide: {
    width: 708,
    height: '100vh',
    backgroundImage: `linear-gradient(0deg, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url(${loginBackground})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    [theme.breakpoints.down('md')]: {
      display: 'none'
    }
  },

  resetPasswordTitleWrapper: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    width: '100%',
    maxWidth: 532,
    '& h1': {
      fontFamily: theme.app.typography.fontFamily.main,
      fontStyle: 'normal',
      fontWeight: 900,
      fontSize: 28,
      lineHeight: '150%',
      color: theme.app.colors.text.light,
      margin: 0
    }
  },

  resetPasswordInfoWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.app.spacing.md,
    width: '100%',
    maxWidth: 500,
    '& h2': {
      fontFamily: theme.app.typography.fontFamily.main,
      fontStyle: 'normal',
      fontWeight: 700,
      fontSize: theme.app.typography.h2.fontSize,
      lineHeight: '150%',
      color: theme.app.colors.text.light,
      margin: 0,
      width: '100%'
    }
  },

  resetPasswordDescription: {
    fontFamily: theme.app.typography.fontFamily.main,
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: theme.app.typography.label.fontSize,
    lineHeight: '150%',
    color: 'rgba(250, 250, 250, 0.8)',
    margin: 0
  },

  resetPasswordLoading: {
    position: 'absolute',
    background: '#fff',
    zIndex: 9999
  },

  resetPasswordInput: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.app.spacing.xs,
    width: '100%',
    marginTop: 0,
    '& label': {
      fontFamily: theme.app.typography.fontFamily.main,
      fontStyle: 'normal',
      fontWeight: 400,
      fontSize: theme.app.typography.label.fontSize,
      lineHeight: '150%',
      color: theme.app.colors.text.light,
      [theme.breakpoints.down('sm')]: {
        fontSize: theme.app.typography.paragraph.fontSize
      }
    },
    '& input': {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      padding: `${theme.app.spacing.md}px ${theme.app.spacing.base}px`,
      width: '100%',
      height: 48,
      background: theme.app.colors.input.background,
      borderRadius: theme.app.borderRadius.sm,
      border: 'none',
      fontFamily: theme.app.typography.fontFamily.main,
      fontStyle: 'normal',
      fontWeight: 400,
      fontSize: theme.app.typography.body.fontSize,
      lineHeight: '150%',
      color: theme.app.colors.text.light,
      boxSizing: 'border-box',
      '&:focus': {
        outline: 'none',
        background: theme.app.colors.input.backgroundFocus
      },
      '&::placeholder': {
        color: 'rgba(250, 250, 250, 0.5)'
      }
    }
  },

  resetPasswordError: {
    fontFamily: theme.app.typography.fontFamily.main,
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: theme.app.typography.paragraph.fontSize,
    lineHeight: '150%',
    color: '#ff6b6b',
    marginTop: theme.app.spacing.xs
  },

  resetPasswordSuccessWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.app.spacing.base,
    width: '100%',
    // maxWidth: 500,
    textAlign: 'center',
    '& h2': {
      fontFamily: theme.app.typography.fontFamily.main,
      fontStyle: 'normal',
      fontWeight: 700,
      fontSize: theme.app.typography.h2.fontSize,
      lineHeight: '150%',
      color: theme.app.colors.text.light,
      margin: 0
    }
  },

  resetPasswordSuccessIcon: {
    width: 80,
    height: 80,
    borderRadius: '50%',
    backgroundColor: '#4caf50',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 48,
    color: '#FFFFFF',
    fontWeight: 'bold',
    marginBottom: theme.app.spacing.sm
  },

  resetPasswordSuccessMessage: {
    fontFamily: theme.app.typography.fontFamily.main,
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: theme.app.typography.body.fontSize,
    lineHeight: '150%',
    color: theme.app.colors.text.light,
    margin: 0,
    '& strong': {
      color: '#dea169'
    }
  },

  resetPasswordSuccessInfo: {
    fontFamily: theme.app.typography.fontFamily.main,
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: theme.app.typography.label.fontSize,
    lineHeight: '150%',
    color: 'rgba(250, 250, 250, 0.7)',
    margin: 0,
    marginTop: theme.app.spacing.sm
  }
}))
